export default __webpack_public_path__ + "static/media/arrow-elbow-down-left.4b13e5b9.svg";